<nav class="navbar navbar-expand-lg fixed-top">
    <div class="container">
        <a class="navbar-brand" (click)="navigateTo(['/splash'])"><img *ngIf="imageUrl" [src]="imageUrl" alt="logo"></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                <li class="nav-item" *ngFor="let option of navOptions">
                    <a class="nav-link active" aria-current="page" (click)="navigateTo(['/splash'])">{{option}}</a>
                </li>
            </ul>

        </div>
    </div>
</nav>
<div class="inner-header">
    <div class="container">
        <h2 class="mt-3 fw-semibold">Privacy Policy</h2>
        <!-- <p>E-mail: <a href="mailto:info@vassardigital.ai">info&#64;vassardigital.ai</a> </p> -->
    </div>
</div>
<div class="container">
    @if(customer === 'nuhospitals' ){
    <h4 class="content">About Application</h4>
        <p>NU INARA: Unified Medical Procedure & Dialysis Management</p>

    <h4 class="content">About Us</h4>
    <p> NU Hospitals has been pioneering in Nephrology, Urology and Fertility (IVF) treatment over the last 25 years.
        Our highly specialised experts are richly experienced in treating rare and complex conditions. It was one of the
        first in Karnataka to conduct a successful kidney transplantation surgery and also the first to equip Urology
        department with the most advanced flexible endoscopes. Having a robust team of subspecialty specific urology
        team at NU Hospitals has significantly improved the overall success rates. Men’s Health Clinic is one of its
        kind in South-India dealing with Men’s Sexual and Reproductive Health. Our Male and Female Fertility (IVF)
        specialists comprehensively support the couples with the latest treatment and heartfelt compassion every step
        along the path to parenthood. At NU Hospitals, every aspect of healthcare is coordinated and the entire team
        works together to provide exactly the care one needs. We are constantly updating the policies and collaborations
        to ensure that people in need are getting access to the most cutting-edge care and treatment.</p>

    <h4 class="content">Therefore, the Company hereby declares that it shall implement the following efforts in carrying
        out its business:</h4>
    <ol>
        <li>The Company shall appropriately acquire, use and provide personal information that may be handled in the
            course of its business, and will not handle the same beyond the scope necessary for achieving the specified
            purpose of use. If the Company handles personal information beyond the scope of the purpose of use, it shall
            obtain the consent of the relevant individual in advance. </li>
        <li> The Company shall comply with any laws and regulations, guidelines and other rules concerning personal
            information. </li>
        <li>The Company shall take reasonable protection and corrective measures against any unauthorized access to, or
            leakage, loss, damage, falsification, etc. of personal information.</li>
        <li>The Company shall promptly respond to any complaint or query from customers concerning personal information.
        </li>
    </ol>
    <p>This app may store in your device or storage unit some data related to specific application or other data in
        order to provide a better user experience. To learn how to delete these data form your device please refer to
        the device manual and/or privacy policy of your device. </p>
    <h4 class="content">Handling of Personal Information:</h4>
    <ol>
        <li>The Company uses personal information to manage information related to users of mobile content.</li>
        <li>The Company will not provide personal information acquired from customers to a third party unless required
            by applicable laws and regulations or the consent of the relevant individual has been obtained.</li>
        <li>The Company may outsource the handling of personal information only to a company selected by the Company as
            being qualified according to the Company's standards.</li>
        <li>The Company may use cookies for convenient use of mobile content; however, it does not connect cookie
            information to the relevant personal information.</li>
        <li> If you have any inquiries or complaints concerning personal information related to notification of the
            purpose of use, disclosure, modification, addition or deletion, discontinuation of use, erasure, or
            discontinuation of provision to a third party, feel free to reach us at the e-mail.</li>
    </ol>

    <h4 class="content">Children Policy:</h4>
    <p> Our Services do not address anyone under the age of 18. We do not knowingly collect personal identifiable
        information from children under 18. In the case we discover that a child under 18 has provided us with personal
        information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that
        your child has provided us with personal information, please contact us so that we can take necessary actions.
    </p>

    <h4 class="content">Permissions used in app:</h4>
    <ol>
        <li>Network access and internet permissions are used to synchronize the data with the cloud.</li>
        <li>Camera permissions are used to capture images and videos.</li>
        <li>Storage permissions are used to store and read files from the phone's memory.</li>
        <li>Location Services has been used to retrieve the location from where the data has been fed into the app.</li>
    </ol>

    <h4 class="content">About Us:</h4>
    <div class="mb-5"> E-mail: <a href="mailto:nuapps@nuhospitals.com">nuapps&#64;nuhospitals.com</a>
        <br>Website: <a href="https://www.nuhospitals.com/">www.nuhospitals.com</a>
    </div>
    } @else if (!policyFetched) {
        <div>Policy Not found</div>
    } @else {
        <div id="policy-viewer"></div>
    }
</div>